module.exports = __webpack_public_path__ + "static/media/zuhauseWohlfuehlen042019.4b56d457.pdf";